import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "py-10 px-4 sm:px-6 lg:px-24" }
const _hoisted_2 = { class: "flex flex-col gap-8" }
const _hoisted_3 = {
  key: 0,
  class: "bg-gradient-to-r from-emerald-800 to-teal-950 rounded-3xl p-6 text-white shadow-lg border border-teal-700/30 flex flex-col md:flex-row items-center justify-between gap-6 relative overflow-hidden"
}
const _hoisted_4 = { class: "flex-grow w-full md:w-auto" }
const _hoisted_5 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_6 = { class: "text-sm text-teal-100 font-semibold leading-relaxed max-w-2xl" }
const _hoisted_7 = { class: "text-white font-extrabold text-lg px-1.5 py-0.5 rounded bg-white/10" }
const _hoisted_8 = { class: "text-emerald-300 font-bold" }
const _hoisted_9 = { class: "font-extrabold" }
const _hoisted_10 = { class: "text-teal-300 font-bold" }
const _hoisted_11 = { class: "mt-5 w-full bg-teal-950/50 rounded-full h-3 border border-teal-800/30" }
const _hoisted_12 = { class: "flex justify-between items-center mt-2 text-xs font-semibold text-teal-300" }
const _hoisted_13 = { class: "flex-shrink-0 w-full md:w-auto text-right" }
const _hoisted_14 = {
  key: 0,
  disabled: "",
  class: "w-full md:w-auto px-6 py-3.5 bg-emerald-900/50 border border-emerald-700/50 text-emerald-300/80 font-extrabold text-sm rounded-xl cursor-not-allowed uppercase tracking-wider"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 2,
  disabled: "",
  class: "w-full md:w-auto px-6 py-3.5 bg-white/20 text-white/50 border border-white/10 font-extrabold text-sm rounded-xl cursor-not-allowed uppercase tracking-wider"
}
const _hoisted_19 = { class: "flow-root mt-4" }
const _hoisted_20 = { class: "-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_21 = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }
const _hoisted_22 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg" }
const _hoisted_23 = { class: "min-w-full divide-y divide-gray-300" }
const _hoisted_24 = { class: "bg-gray-50" }
const _hoisted_25 = {
  key: 0,
  scope: "col",
  class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
}
const _hoisted_26 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_27 = { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-900 sm:pl-6" }
const _hoisted_28 = {
  key: 0,
  class: "ml-2 px-1.5 py-0.5 rounded text-[10px] font-bold bg-rose-50 text-rose-700 border border-rose-200 uppercase"
}
const _hoisted_29 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-semibold" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 1,
  class: "text-gray-400 font-normal"
}
const _hoisted_32 = {
  key: 0,
  class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500"
}
const _hoisted_33 = {
  key: 0,
  class: "ml-1.5 px-1 py-0.5 rounded bg-gray-100 text-gray-600 text-[10px] font-medium border border-gray-200"
}
const _hoisted_34 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = ["colspan"]
const _hoisted_37 = {
  key: 0,
  class: "flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6"
}
const _hoisted_38 = { class: "flex flex-1 justify-between sm:hidden" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "hidden sm:flex sm:flex-1 sm:items-center sm:justify-between" }
const _hoisted_42 = { class: "text-xs font-semibold text-gray-500" }
const _hoisted_43 = { class: "font-bold text-gray-900" }
const _hoisted_44 = { class: "font-bold text-gray-900" }
const _hoisted_45 = { class: "font-bold text-gray-900" }
const _hoisted_46 = {
  class: "isolate inline-flex -space-x-px rounded-md shadow-sm",
  "aria-label": "Pagination"
}
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["disabled"]
const _hoisted_50 = { class: "w-full max-w-md mx-auto bg-white rounded-3xl p-6 md:p-8 shadow-[0_12px_40px_rgba(0,0,0,0.12)] border border-slate-100 flex flex-col relative" }
const _hoisted_51 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-6 text-center"
}
const _hoisted_52 = { class: "mt-2 text-sm text-gray-500 leading-relaxed max-w-xs font-regular text-center" }
const _hoisted_53 = { class: "block mt-1 font-bold text-rose-600 tracking-wide" }
const _hoisted_54 = {
  key: 1,
  class: "flex flex-col gap-6"
}
const _hoisted_55 = { class: "bg-gray-50 rounded-2xl p-5 border border-gray-200/60 flex flex-col gap-3 text-left" }
const _hoisted_56 = { class: "flex justify-between border-b border-gray-200/40 pb-2" }
const _hoisted_57 = { class: "text-sm font-bold text-gray-800" }
const _hoisted_58 = { class: "flex justify-between border-b border-gray-200/40 pb-2" }
const _hoisted_59 = { class: "text-sm font-bold text-gray-800" }
const _hoisted_60 = { class: "flex justify-between border-b border-gray-200/40 pb-2" }
const _hoisted_61 = { class: "text-sm font-bold text-gray-800" }
const _hoisted_62 = { class: "flex justify-between pb-1" }
const _hoisted_63 = { class: "text-sm font-bold text-gray-800" }
const _hoisted_64 = { class: "flex flex-col gap-2 text-left" }
const _hoisted_65 = { class: "relative rounded-xl border border-gray-200 flex items-center bg-gray-50 focus-within:bg-white focus-within:border-theme-active transition-all duration-200" }
const _hoisted_66 = ["max"]
const _hoisted_67 = { class: "pr-4 text-xs font-bold text-emerald-600 whitespace-nowrap" }
const _hoisted_68 = {
  key: 0,
  class: "text-xs text-rose-600 font-semibold mt-1"
}
const _hoisted_69 = { class: "text-[11px] text-gray-400 mt-1 font-medium" }
const _hoisted_70 = { class: "text-gray-700 font-bold" }
const _hoisted_71 = { class: "flex items-center justify-end gap-3 mt-4" }
const _hoisted_72 = ["disabled"]
const _hoisted_73 = {
  key: 0,
  class: "animate-spin h-3.5 w-3.5 text-white",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_74 = {
  key: 0,
  class: "text-ef-error mt-2 text-left text-xs font-semibold"
}

import { ref, onMounted, computed } from 'vue'
import { isLoggedIn, handleApiError, logout } from '@/utils/common'
import Agent from '@/composables/admin/agent'
import Modal from '@/widgets/Modal.vue'
import Loader from '@/widgets/Loader.vue'
import Notification from '@/widgets/Notification.vue'
import { NotificationType } from '@/types/index'
import router from '@/router'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoyaltyPoints',
  setup(__props) {

const auth = isLoggedIn()
const isAgencyAdmin = computed(() => auth && auth.user && auth.user.type === 'agent' && auth.user.sub_type === null)

const isLoading = ref<boolean>(true)
const isBusy = ref<boolean>(false)
const openModal = ref<boolean>(false)
const { loyaltyLogs, requestRedeemLoyalty, agentProfile } = Agent()

const logs = ref<any[]>([])
const loyaltySummary = ref<any>(null)
const currentPage = ref<number>(1)
const totalPages = ref<number>(1)
const totalRecords = ref<number>(0)
const limit = ref<number>(10)

const notif = ref<NotificationType>({ show: false, type: 'success', message: '', messageDetails: '' })

const loyaltyRedeemForm = ref<any>({
   bankName: { value: '', error: false, errorMessage: '' },
   accountName: { value: '', error: false, errorMessage: '' },
   accountNumber: { value: '', error: false, errorMessage: '' },
   countryName: { value: '', error: false, errorMessage: '' },
   error: ''
})

const agentProfileDetails = ref<any>(null)
const pointsToWithdraw = ref<number | null>(null)
const pointsError = ref<string>('')
const isProfileLoading = ref<boolean>(false)

const missingBankFields = computed(() => {
   const missing = []
   if (!agentProfileDetails.value) return ['Bank Name', 'Account Title', 'Account Number/IBAN', 'Country']
   if (!agentProfileDetails.value.bank_name) missing.push('Bank Name')
   if (!agentProfileDetails.value.bank_account_name) missing.push('Account Title')
   if (!agentProfileDetails.value.bank_account_number) missing.push('Account Number or IBAN')
   if (!agentProfileDetails.value.country) missing.push('Country')
   return missing
})

onMounted(async () => {
   await fetchLoyaltyData()
})

const fetchLoyaltyData = async () => {
   isLoading.value = true
   const response = await loyaltyLogs(currentPage.value, limit.value)
   isLoading.value = false

   if (response.status === 200) {
      logs.value = response.data.logs || []
      loyaltySummary.value = response.data.loyalty_summary || null
      totalPages.value = response.data.last_page || 1
      totalRecords.value = response.data.total || 0
   } else if (response.response && response.response.status === 401) {
      logout(router)
   } else {
      const errorMsg = handleApiError(response)
      notif.value = { show: true, type: 'error', message: 'Failed to load', messageDetails: errorMsg }
      setTimeout(() => { notifClosed() }, 5000)
   }
}

const changePage = async (page: number) => {
   if (page >= 1 && page <= totalPages.value) {
      currentPage.value = page
      await fetchLoyaltyData()
   }
}

const visiblePages = computed(() => {
   const pages = []
   const start = Math.max(1, currentPage.value - 2)
   const end = Math.min(totalPages.value, currentPage.value + 2)
   for (let i = start; i <= end; i++) {
      pages.push(i)
   }
   return pages
})

const handleRedeemPoints = async () => {
   isProfileLoading.value = true
   const profileRes = await agentProfile()
   isProfileLoading.value = false
   if (profileRes.status === 200) {
      agentProfileDetails.value = profileRes.data.data
      
      loyaltyRedeemForm.value.bankName.value = profileRes.data.data.bank_name || ''
      loyaltyRedeemForm.value.accountName.value = profileRes.data.data.bank_account_name || ''
      loyaltyRedeemForm.value.accountNumber.value = profileRes.data.data.bank_account_number || ''
      loyaltyRedeemForm.value.countryName.value = profileRes.data.data.country || ''
      
      pointsToWithdraw.value = loyaltySummary.value ? Math.floor(Number(loyaltySummary.value.points_earned)) : 0
   }
   openModal.value = true
}

const handleModalClose = () => {
   openModal.value = false
}

const notifClosed = () => {
   notif.value.show = false
}

const validateForm = (): boolean => {
   pointsError.value = ''
   let response = true
   
   if (!pointsToWithdraw.value || pointsToWithdraw.value <= 0) {
      pointsError.value = 'Please enter a valid points amount'
      response = false
   } else if (loyaltySummary.value && pointsToWithdraw.value > Number(loyaltySummary.value.points_earned)) {
      pointsError.value = 'Cannot exceed your accumulated points'
      response = false
   }

   return response
}

const handleModalSubmit = async () => {
   const isValid = validateForm()

   if (isValid && !isBusy.value && auth && auth.user) {
      isBusy.value = true
      const response = await requestRedeemLoyalty(loyaltyRedeemForm.value, pointsToWithdraw.value || 0)
      isBusy.value = false

      if (response.status === 200) {
         openModal.value = false
         notif.value = { show: true, type: 'success', message: 'Success', messageDetails: 'Redemption request submitted successfully' }
         setTimeout(() => { notifClosed() }, 4000)
         await fetchLoyaltyData()
      } else {
         const errorMsg = handleApiError(response)
         loyaltyRedeemForm.value.error = errorMsg
      }
   }
}

const formatDate = (dateStr: string) => {
   if (!dateStr) return '-'
   try {
      const [datePart] = dateStr.split(' ')
      const [year, month, day] = datePart.split('-')
      return `${day}-${month}-${year}`
   } catch (e) {
      return dateStr
   }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("main", _hoisted_2, [
        _cache[26] || (_cache[26] = _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "text-xl font-bold text-gray-900" }, "Loyalty Program"),
          _createElementVNode("p", { class: "text-xs font-semibold text-gray-500 mt-1" }, "Track your agency rewards points and ledger logs")
        ], -1)),
        (isAgencyAdmin.value && loyaltySummary.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "absolute -right-16 -top-16 w-48 h-48 bg-teal-500/10 rounded-full blur-3xl pointer-events-none" }, null, -1)),
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "absolute -left-16 -bottom-16 w-48 h-48 bg-emerald-500/10 rounded-full blur-3xl pointer-events-none" }, null, -1)),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-gift",
                    class: "text-xl text-emerald-400"
                  }),
                  _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-lg font-extrabold tracking-wide uppercase" }, "Loyalty Program Reward", -1))
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-xs text-emerald-300 font-semibold mb-3" }, " * Loyalty Program will be calculated from 01-07-2026 ", -1)),
                _createElementVNode("p", _hoisted_6, [
                  _cache[6] || (_cache[6] = _createTextVNode(" You have accumulated ")),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(loyaltySummary.value.points_earned), 1),
                  _cache[7] || (_cache[7] = _createTextVNode(" points (")),
                  _createElementVNode("span", _hoisted_8, "$" + _toDisplayString((Number(loyaltySummary.value.points_earned) * (Number(loyaltySummary.value.redeem_rate) || 0.1)).toFixed(2)) + " USD", 1),
                  _cache[8] || (_cache[8] = _createTextVNode("). Reach the target of ")),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(loyaltySummary.value.total_points), 1),
                  _cache[9] || (_cache[9] = _createTextVNode(" points (")),
                  _createElementVNode("span", _hoisted_10, "$" + _toDisplayString((Number(loyaltySummary.value.total_points) * (Number(loyaltySummary.value.redeem_rate) || 0.1)).toFixed(2)) + " USD", 1),
                  _cache[10] || (_cache[10] = _createTextVNode(") to request a withdrawal! "))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: "bg-gradient-to-r from-emerald-400 to-teal-300 h-full rounded-full transition-all duration-500 shadow-[0_0_8px_rgba(52,211,153,0.5)]",
                    style: _normalizeStyle({ width: `${Math.min(100, ((Number(loyaltySummary.value.points_earned) || 0) / Math.max(1, Number(loyaltySummary.value.total_points) || 1)) * 100)}%` })
                  }, null, 4)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[11] || (_cache[11] = _createElementVNode("span", null, "0 Points", -1)),
                  _createElementVNode("span", null, _toDisplayString(Math.min(100, Math.round(((Number(loyaltySummary.value.points_earned) || 0) / Math.max(1, Number(loyaltySummary.value.total_points) || 1)) * 100))) + "% Completed", 1),
                  _createElementVNode("span", null, _toDisplayString(loyaltySummary.value.total_points) + " Points Target", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                (loyaltySummary.value.pending_withdraw)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_14, " Withdrawal Processing "))
                  : (Number(loyaltySummary.value.points_earned) >= Number(loyaltySummary.value.total_points))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: handleRedeemPoints,
                        disabled: isProfileLoading.value,
                        class: "w-full md:w-auto px-6 py-3.5 bg-white text-emerald-900 hover:bg-emerald-50 active:scale-[0.98] transition-all duration-200 font-extrabold text-sm rounded-xl shadow-md uppercase tracking-wider min-w-[160px] text-center flex items-center justify-center"
                      }, [
                        (isProfileLoading.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _cache[13] || (_cache[13] = [
                              _createElementVNode("svg", {
                                class: "animate-spin h-4 w-4 text-emerald-900",
                                fill: "none",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("circle", {
                                  class: "opacity-25",
                                  cx: "12",
                                  cy: "12",
                                  r: "10",
                                  stroke: "currentColor",
                                  "stroke-width": "4"
                                }),
                                _createElementVNode("path", {
                                  class: "opacity-75",
                                  fill: "currentColor",
                                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                })
                              ], -1),
                              _createTextVNode(" Loading... ")
                            ])))
                          : (_openBlock(), _createElementBlock("span", _hoisted_17, "Withdraw Now"))
                      ], 8, _hoisted_15))
                    : (_openBlock(), _createElementBlock("button", _hoisted_18, " Withdraw Now "))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("table", _hoisted_23, [
                  _createElementVNode("thead", _hoisted_24, [
                    _createElementVNode("tr", null, [
                      _cache[16] || (_cache[16] = _createElementVNode("th", {
                        scope: "col",
                        class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                      }, "Date", -1)),
                      _cache[17] || (_cache[17] = _createElementVNode("th", {
                        scope: "col",
                        class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      }, "Booking ID", -1)),
                      (isAgencyAdmin.value)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_25, "Earned By"))
                        : _createCommentVNode("", true),
                      _cache[18] || (_cache[18] = _createElementVNode("th", {
                        scope: "col",
                        class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      }, "Booking Amount", -1)),
                      _cache[19] || (_cache[19] = _createElementVNode("th", {
                        scope: "col",
                        class: "px-3 py-3.5 text-right text-sm font-semibold text-gray-900 pr-6"
                      }, "Points", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logs.value, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id
                      }, [
                        _createElementVNode("td", _hoisted_27, [
                          _createTextVNode(_toDisplayString(formatDate(item.created_at)) + " ", 1),
                          (item.description && item.description.includes('Withdrawal'))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Payout"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_29, [
                          (item.booking_number)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(item.booking_number), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_31, "-"))
                        ]),
                        (isAgencyAdmin.value)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_32, [
                              _createTextVNode(_toDisplayString(item.agent_name) + " ", 1),
                              (item.agent_id === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, "System"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", _hoisted_34, _toDisplayString(item.amount_usd ? `$${Number(item.amount_usd).toFixed(2)}` : '-'), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass(["whitespace-nowrap px-3 py-4 text-sm text-right pr-6 font-bold", Number(item.points) >= 0 ? 'text-emerald-600' : 'text-rose-600'])
                        }, _toDisplayString(Number(item.points) >= 0 ? `+${Number(item.points).toFixed(2)}` : Number(item.points).toFixed(2)), 3)
                      ]))
                    }), 128)),
                    (logs.value && logs.value.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_35, [
                          _createElementVNode("td", {
                            colspan: isAgencyAdmin.value ? 5 : 4,
                            class: "text-center whitespace-nowrap py-8 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6"
                          }, " No loyalty point transactions found. ", 8, _hoisted_36)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (totalPages.value > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (changePage(currentPage.value - 1))),
                          disabled: currentPage.value === 1,
                          class: "relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                        }, "Previous", 8, _hoisted_39),
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (changePage(currentPage.value + 1))),
                          disabled: currentPage.value === totalPages.value,
                          class: "relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                        }, "Next", 8, _hoisted_40)
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", null, [
                          _createElementVNode("p", _hoisted_42, [
                            _cache[20] || (_cache[20] = _createTextVNode(" Showing ")),
                            _createElementVNode("span", _hoisted_43, _toDisplayString((currentPage.value - 1) * limit.value + 1), 1),
                            _cache[21] || (_cache[21] = _createTextVNode(" to ")),
                            _createElementVNode("span", _hoisted_44, _toDisplayString(Math.min(currentPage.value * limit.value, totalRecords.value)), 1),
                            _cache[22] || (_cache[22] = _createTextVNode(" of ")),
                            _createElementVNode("span", _hoisted_45, _toDisplayString(totalRecords.value), 1),
                            _cache[23] || (_cache[23] = _createTextVNode(" results "))
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("nav", _hoisted_46, [
                            _createElementVNode("button", {
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (changePage(currentPage.value - 1))),
                              disabled: currentPage.value === 1,
                              class: "relative inline-flex items-center rounded-l-md px-2 py-1.5 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 disabled:opacity-50"
                            }, _cache[24] || (_cache[24] = [
                              _createElementVNode("span", { class: "sr-only" }, "Previous", -1),
                              _createElementVNode("svg", {
                                class: "h-4 w-4",
                                viewBox: "0 0 20 20",
                                fill: "currentColor",
                                "aria-hidden": "true"
                              }, [
                                _createElementVNode("path", {
                                  "fill-rule": "evenodd",
                                  d: "M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z",
                                  "clip-rule": "evenodd"
                                })
                              ], -1)
                            ]), 8, _hoisted_47),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: page,
                                onClick: ($event: any) => (changePage(page)),
                                class: _normalizeClass(page === currentPage.value ? 'relative z-10 inline-flex items-center bg-emerald-600 px-3 py-1 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600' : 'relative inline-flex items-center px-3 py-1 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0')
                              }, _toDisplayString(page), 11, _hoisted_48))
                            }), 128)),
                            _createElementVNode("button", {
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (changePage(currentPage.value + 1))),
                              disabled: currentPage.value === totalPages.value,
                              class: "relative inline-flex items-center rounded-r-md px-2 py-1.5 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 disabled:opacity-50"
                            }, _cache[25] || (_cache[25] = [
                              _createElementVNode("span", { class: "sr-only" }, "Next", -1),
                              _createElementVNode("svg", {
                                class: "h-4 w-4",
                                viewBox: "0 0 20 20",
                                fill: "currentColor",
                                "aria-hidden": "true"
                              }, [
                                _createElementVNode("path", {
                                  "fill-rule": "evenodd",
                                  d: "M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z",
                                  "clip-rule": "evenodd"
                                })
                              ], -1)
                            ]), 8, _hoisted_49)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(Modal, {
      show: openModal.value,
      canClose: true,
      onClosed: handleModalClose
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", { class: "flex items-center justify-between mb-6 pb-4 border-b border-gray-100" }, [
            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "text-left" }, [
              _createElementVNode("h2", { class: "text-lg font-bold text-gray-900 tracking-tight" }, "Request Loyalty Points Payout"),
              _createElementVNode("p", { class: "text-xs text-gray-500 font-medium mt-1" }, "Review bank details and confirm cashout points.")
            ], -1)),
            _createElementVNode("button", {
              onClick: handleModalClose,
              class: "text-gray-400 hover:text-gray-600 transition-colors p-1.5 hover:bg-gray-50 rounded-lg"
            }, _cache[27] || (_cache[27] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                "stroke-width": "2",
                stroke: "currentColor",
                class: "w-5 h-5"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ]))
          ]),
          (!agentProfileDetails.value || !agentProfileDetails.value.bank_name || !agentProfileDetails.value.bank_account_name || !agentProfileDetails.value.bank_account_number || !agentProfileDetails.value.country)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "h-16 w-16 bg-rose-50 rounded-full flex items-center justify-center text-rose-500 mb-4 ring-8 ring-rose-50/50" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    "stroke-width": "2",
                    stroke: "currentColor",
                    class: "w-8 h-8"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    })
                  ])
                ], -1)),
                _cache[32] || (_cache[32] = _createElementVNode("h3", { class: "text-base font-bold text-gray-900" }, "Missing Bank Details", -1)),
                _createElementVNode("p", _hoisted_52, [
                  _cache[29] || (_cache[29] = _createTextVNode(" Kindly fill the missing bank details in your profile first: ")),
                  _createElementVNode("span", _hoisted_53, _toDisplayString(missingBankFields.value.join(', ')), 1)
                ]),
                _createVNode(_component_router_link, {
                  to: "/agent/settings",
                  class: "mt-6 px-5 py-3 bg-theme-active hover:bg-theme-active/95 text-white font-extrabold text-xs uppercase tracking-wider rounded-xl transition-all shadow-md active:scale-95 text-center"
                }, {
                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                    _createTextVNode(" Go to Profile Settings ")
                  ])),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _cache[33] || (_cache[33] = _createElementVNode("span", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider" }, "Bank Name", -1)),
                    _createElementVNode("span", _hoisted_57, _toDisplayString(agentProfileDetails.value.bank_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _cache[34] || (_cache[34] = _createElementVNode("span", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider" }, "Account Title", -1)),
                    _createElementVNode("span", _hoisted_59, _toDisplayString(agentProfileDetails.value.bank_account_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _cache[35] || (_cache[35] = _createElementVNode("span", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider" }, "Account / IBAN", -1)),
                    _createElementVNode("span", _hoisted_61, _toDisplayString(agentProfileDetails.value.bank_account_number), 1)
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _cache[36] || (_cache[36] = _createElementVNode("span", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider" }, "Bank Country", -1)),
                    _createElementVNode("span", _hoisted_63, _toDisplayString(agentProfileDetails.value.country || '-'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _cache[38] || (_cache[38] = _createElementVNode("label", {
                    for: "withdraw-points",
                    class: "uppercase text-xs font-extrabold text-gray-400 tracking-wider"
                  }, "Points to Withdraw *", -1)),
                  _createElementVNode("div", _hoisted_65, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((pointsToWithdraw).value = $event)),
                      type: "number",
                      id: "withdraw-points",
                      max: loyaltySummary.value.points_earned,
                      placeholder: "Enter points count",
                      class: "w-full bg-transparent outline-none p-3.5 font-bold text-gray-800 text-base"
                    }, null, 8, _hoisted_66), [
                      [_vModelText, pointsToWithdraw.value]
                    ]),
                    _createElementVNode("span", _hoisted_67, " $" + _toDisplayString((Number(pointsToWithdraw.value || 0) * (Number(loyaltySummary.value.redeem_rate) || 0.1)).toFixed(2)) + " USD ", 1)
                  ]),
                  (pointsError.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(pointsError.value), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_69, [
                    _cache[37] || (_cache[37] = _createTextVNode("Available loyalty points balance: ")),
                    _createElementVNode("strong", _hoisted_70, _toDisplayString(loyaltySummary.value.points_earned), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: handleModalClose,
                    class: "px-5 py-2.5 bg-gray-100 hover:bg-gray-200 rounded-xl text-xs font-bold text-gray-600 uppercase transition-all"
                  }, "Cancel"),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: handleModalSubmit,
                    disabled: isBusy.value,
                    class: "px-5 py-2.5 bg-theme-active hover:bg-theme-active/95 text-white rounded-xl text-xs font-bold uppercase transition-all flex items-center gap-1.5 shadow-md disabled:opacity-50"
                  }, [
                    (isBusy.value)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_73, _cache[39] || (_cache[39] = [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }, null, -1),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          }, null, -1)
                        ])))
                      : _createCommentVNode("", true),
                    _cache[40] || (_cache[40] = _createTextVNode(" Confirm Payout "))
                  ], 8, _hoisted_72)
                ]),
                (loyaltyRedeemForm.value.error)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_74, _toDisplayString(loyaltyRedeemForm.value.error), 1))
                  : _createCommentVNode("", true)
              ]))
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(Notification, {
      show: notif.value.show,
      type: notif.value.type,
      message: notif.value.message,
      messageDetails: notif.value.messageDetails,
      onClosed: notifClosed
    }, null, 8, ["show", "type", "message", "messageDetails"]),
    _createVNode(Loader, { show: isLoading.value }, null, 8, ["show"])
  ], 64))
}
}

})